import { render, staticRenderFns } from "./GoalEditPanel.vue?vue&type=template&id=003966bb&scoped=true&"
import script from "./GoalEditPanel.vue?vue&type=script&lang=js&"
export * from "./GoalEditPanel.vue?vue&type=script&lang=js&"
import style0 from "./GoalEditPanel.vue?vue&type=style&index=0&id=003966bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003966bb",
  null
  
)

/* custom blocks */
import block0 from "./GoalEditPanel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('003966bb')) {
      api.createRecord('003966bb', component.options)
    } else {
      api.reload('003966bb', component.options)
    }
    module.hot.accept("./GoalEditPanel.vue?vue&type=template&id=003966bb&scoped=true&", function () {
      api.rerender('003966bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goal/GoalEditPanel.vue"
export default component.exports